<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

export default {
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  watch: {
    $route() {
      var vm = this;

      vm.load();
    },
  },
  methods: {
    load() {
      var vm = this;

      if (vm.$route.params.id) {
        vm.create();
      } else {
        vm.newData();
      }
    },
    newData() {
      var vm = this;

      var data = {
        id: null,
        ref_no: null,
        name: null,
        email: null,
        // phone: null,

        permission_id: null,

        password: null,
        password_confirmation: null
      };

      vm.data = Object.assign({}, data);
    },
    async create() {
      var vm = this;

      this.$loading.on('user_detail_create');
      try {
        vm.newData();

        var resp = await this.$api.User.get(vm.$route.params.id);
        var data = resp.data.data;

        vm.data = Object.assign({}, data)

        this.$loading.off('user_detail_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async submit() {
      var vm = this;
      this.$loading.on('user_detail_submit');

      try {
        var postData = vm._createPostData(vm.data);
        var resp = await this.$api.User.create(postData);

        var data = resp.data;

        vm.$ac.refresh();

        if (vm.$route.params.id) {
          vm.create();
        } else {
          vm.$router.push({ name: 'user-detail', params: { id: data.data } });
        }

        this.$flash.success(data.message);
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
      this.$loading.off('user_detail_submit');
    },
    _createPostData(data) {

      return data;
    },
    fetchPermission: async function (params) {
      const resp = await this.$api.PermissionGroup.all(params)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    async sendEmailVerification() {
      var vm = this;

      try {
        vm.$loading.on('user_detail_email_verification');

        var params = {
          id: vm.data.id
        }

        var resp = await vm.$api.User.verifyEmail(params);

        vm.$flash.success(resp.data.message);
      } catch (error) {
        vm.$flash.error(error.response.data.message);
      }

      vm.$loading.off('user_detail_email_verification');
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('user.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />

    <div class="position-relative mx-n4 mt-n4">
      <div class="profile-wid-bg profile-setting-img">

        <div class="overlay-content">
          <div class="text-end p-3">
            <div class="p-0 ms-auto rounded-circle profile-photo-edit">
            </div>
          </div>
        </div>
      </div>
    </div>

    <BRow>
      <BCol xxl="3">
        <BCard no-body class="mt-n5">
          <BCardBody class="p-3">
            <div class="text-center">
              <!-- <div class="
                  profile-user
                  position-relative
                  d-inline-block
                  mx-auto
                  mb-4
                ">
                <img src="@/assets/images/cafeman/user.svg" class="
                    rounded-circle
                    avatar-xl
                    img-thumbnail
                    user-profile-image
                    shadow
                  " alt="user-profile-image" />
                <div class="avatar-xs p-0 rounded-circle profile-photo-edit">
                  <input id="profile-img-file-input" type="file" class="profile-img-file-input" />
                  <label for="profile-img-file-input" class="profile-photo-edit avatar-xs">
                    <span class="avatar-title rounded-circle bg-light text-body shadow">
                      <i class="ri-camera-fill"></i>
                    </span>
                  </label>
                </div>
              </div> -->
              <div class="d-flex justify-content-center mb-3 mt-3">
                <div class="avatar-lg">
                  <div
                    class="avatar-title bg-light text-dark rounded-circle d-flex align-items-center justify-content-center">
                    <i class="mdi mdi-account-outline" style="font-size: 50px;"></i>
                  </div>
                </div>
              </div>
              <skeleton :loading="$loading.get('user_detail_create')" :schema="['col-10', 'col-4']">
                <h5 class="fs-16 mb-1">{{ data.name }}</h5>
                <p class="text-muted mb-0">{{ data.ref_no }}</p>
              </skeleton>
            </div>
          </BCardBody>
        </BCard>
      </BCol>
      <BCol xxl="9">
        <BTabs nav-class="profile-nav gap-1 gap-lg-2 text-muted mt-n5" pills lazy>
          <BTab class="nav-item pt-4">
            <template #title>
              <i class="mdi mdi-chart-line d-inline-block d-md-none"></i>
              <span class="d-none d-md-inline-block">{{ $t('user.tab.detail') }}</span>
            </template>
            <BRow>
              <BCol lg="12">
                <BCard no-body>
                  <b-form @submit="submit">
                    <BCardBody>
                      <loading :loading="$loading.get('user_detail_create')" variant="dark" type="block">
                        <BRow class="pt-3 mb-3">
                          <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('user_full_access')">
                            <label class="form-label" for="product-title-input">{{ $t('user.label.ref_no')
                            }}</label>
                            <input type="text" class="form-control" v-model="data.ref_no" id="product-title-input"
                              :placeholder="$t('user.placeholder.ref_no')" />
                          </BCol>
                          <BCol lg="6">
                            <div>
                              <label for="name" class="form-label">{{ $t('user.label.name') }}</label>
                              <input type="text" v-model="data.name" class="form-control" id="name"
                                :placeholder="$t('user.placeholder.name')" />
                            </div>
                          </BCol>
                          <BCol lg="6">
                            <div>
                              <label for="email" class="form-label">{{ $t('user.label.email') }}</label>
                              <input type="email" v-model="data.email" class="form-control" id="email"
                                :placeholder="$t('user.placeholder.email')" />
                            </div>
                          </BCol>
                        </BRow>
                      </loading>
                    </BCardBody>
                    <BCardFooter v-if="($ac.hasAccess('user_full_access'))">
                      <div class="hstack gap-2 justify-content-end">
                        <BButton type="submit" variant="success" class="w-sm"
                          :disabled="$loading.get('user_detail_submit')" v-if="($ac.hasAccess('user_full_access'))">
                          <loading :loading="$loading.get('user_detail_submit')">
                            <i class="mdi mdi-floppy me-1"></i>
                            {{ $t('basic.btn.save') }}
                          </loading>
                        </BButton>
                      </div>
                    </BCardFooter>
                  </b-form>
                </BCard>
              </BCol>
            </BRow>
          </BTab>
          <BTab class="nav-item pt-4">
            <template #title>
              <i class="mdi mdi-cog-outline d-inline-block d-md-none"></i>
              <span class="d-none d-md-inline-block">{{ $t('user.tab.password') }}</span>
            </template>
            <BRow>
              <BCol lg="12">
                <BCard no-body>
                  <b-form @submit="submit">
                    <BCardBody>
                      <loading :loading="$loading.get('user_detail_create')" variant="dark" type="block">
                        <BRow class="pt-3 mb-3">
                          <BCol lg="6" class="mb-3">
                            <div>
                              <label for="newpasswordInput" class="form-label">{{ $t('user.label.password') }}</label>
                              <input type="password" v-model="data.password" class="form-control" id="newpasswordInput"
                                :placeholder="$t('user.placeholder.password')" />
                            </div>
                          </BCol>
                          <BCol lg="6">
                            <div>
                              <label for="confirmpasswordInput" class="form-label">{{ $t('user.label.retype_password')
                              }}</label>
                              <input type="password" v-model="data.password_confirmation" class="form-control"
                                id="confirmpasswordInput" :placeholder="$t('user.placeholder.retype_password')" />
                            </div>
                          </BCol>
                        </BRow>
                      </loading>
                    </BCardBody>
                    <BCardFooter v-if="($ac.hasAccess('user_full_access'))">
                      <div class="hstack gap-2 justify-content-end">
                        <BButton type="submit" variant="success" class="w-sm"
                          :disabled="$loading.get('user_detail_submit')" v-if="($ac.hasAccess('user_full_access'))">
                          <loading :loading="$loading.get('user_detail_submit')">
                            <i class="mdi mdi-floppy me-1"></i>
                            {{ $t('basic.btn.save') }}
                          </loading>
                        </BButton>
                      </div>
                    </BCardFooter>
                  </b-form>
                </BCard>
              </BCol>
            </BRow>
          </BTab>
          <BTab class="nav-item pt-4" v-if="$ac.hasAccess('user_full_access') && data.id">
            <template #title>
              <i class="mdi mdi-cog-outline d-inline-block d-md-none"></i>
              <span class="d-none d-md-inline-block">{{ $t('user.tab.config') }}</span>
            </template>
            <BRow>
              <BCol lg="12">
                <BCard no-body>
                  <b-form @submit="submit">
                    <BCardBody>
                      <loading :loading="$loading.get('user_detail_create')" variant="dark" type="block">
                        <BRow class="pt-3">
                          <BCol class="mb-3" lg="6" v-if="$ac.hasAccess('user_full_access')">
                            <label for="choices-publish-status-input" class="form-label">{{
                              $t('user.label.permission')
                            }}</label>
                            <dynamic-select v-model="data.permission_id" :loadOptions="fetchPermission"
                              :placeholder="$t('user.placeholder.permission')" />
                          </BCol>
                          <BCol class="mb-3" lg="6" v-if="$ac.hasAccess('user_full_access')">
                            <label class="form-label" for="product-title-input">{{ $t('user.label.email_verified_at')
                            }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" v-model="data.email_verified_at"
                                :placeholder="$t('user.placeholder.email_verified_at')" :disabled="true" />
                              <BButton variant="info" type="button" v-if="data.id && $ac.hasAccess('user_full_access')"
                                @click="sendEmailVerification"
                                :disabled="$loading.get('user_detail_email_verification')">
                                <loading :loading="$loading.get('user_detail_email_verification')" variant="light"
                                  type="button">
                                  <i class="mdi mdi-email-outline me-1"></i>
                                  {{ $t('basic.btn.resend') }}
                                </loading>
                              </BButton>
                            </div>
                          </BCol>
                        </BRow>
                      </loading>
                    </BCardBody>
                    <BCardFooter v-if="($ac.hasAccess('user_full_access'))">
                      <div class="hstack gap-2 justify-content-end">
                        <BButton type="submit" variant="success" class="w-sm"
                          :disabled="$loading.get('user_detail_submit')" v-if="($ac.hasAccess('user_full_access'))">
                          <loading :loading="$loading.get('user_detail_submit')">
                            <i class="mdi mdi-floppy me-1"></i>
                            {{ $t('basic.btn.save') }}
                          </loading>
                        </BButton>
                      </div>
                    </BCardFooter>
                  </b-form>
                </BCard>
              </BCol>
            </BRow>
          </BTab>
        </BTabs>
      </BCol>
    </BRow>
  </Layout>
</template>

<style>
.profile-setting-img {
  height: 200px !important;
}
</style>